/* eslint-disable @typescript-eslint/no-explicit-any */
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import createSagaMiddleware from 'redux-saga';
import {history} from 'utils'
import sagas from './rootSaga';
import rootReducer from './reducers'
import { routerMiddleware } from 'connected-react-router';

const developmentMode = process.env.NODE_ENV === 'development';

const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer(persistConfig, rootReducer as ReturnType<any>);

const sagaMiddleware = createSagaMiddleware();


const store = configureStore({
  devTools: developmentMode,
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(sagaMiddleware, routerMiddleware(history)),
});

export type AppDispatch = typeof store.dispatch;

sagaMiddleware.run(sagas);

export default store;
